/** Bridges WebSocket topic activity → StyxAppShell (list refetch) and debounced mark-read. */

export type WorkspaceTopicUiSink = {
  notifyListRefresh: (workspaceId: string) => void;
  scheduleMarkTopicRead: (workspaceId: string, topicId: string) => void;
};

let sink: WorkspaceTopicUiSink | null = null;

export function registerWorkspaceTopicUiSink(next: WorkspaceTopicUiSink | null): void {
  sink = next;
}

export function notifyWorkspaceTopicListStale(workspaceId: string): void {
  sink?.notifyListRefresh(workspaceId);
}

export function scheduleWorkspaceTopicMarkRead(workspaceId: string, topicId: string): void {
  sink?.scheduleMarkTopicRead(workspaceId, topicId);
}
